var responsiveflagMenu = false;
var menuGroov = $('header .navbar-header');

$(document).ready(function(){
	menuGroov = $('header .navbar-header');
	responsiveMenu();
	$(window).resize(responsiveMenu);
	$(".arrow-button").on( "click", function() {
		ScrollToTopProcess();
	  });
	var isMobile = false;
	// device detection
	if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iP(hone|od)|ipad|iPad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
	    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
	    isMobile = true;
	}
	// isMobile = true;
	if (isMobile) {

	    $('.mainnavi .top-menu.level_1 > li.submenu > a.submenu').css("padding-right","0").after($('<span class="aftrelink"></span>').css({"padding-left": "0", "cursor":"pointer"}));
	    $('.mainnavi .top-menu.level_1 > li.submenu > span.forward.trail.submenu').css("padding-right","0").after($('<span class="aftrelink"></span>').css({"padding-left": "0", "cursor":"pointer"}));

	    $(document).click(function(event) {
	        var click_el = $(event.target);
	        if (click_el.hasClass('aftrelink')) {
	            if (click_el.hasClass('menu-vis-tog')) {
	                if (click_el.next('ul').hasClass('menu-vis')) {
	                    click_el.next('ul').removeClass('menu-vis');
	                }
	                click_el.removeClass('menu-vis-tog');
	            } else {
	                $('ul.menu-vis').removeClass('menu-vis');
	                $('.aftrelink').removeClass('menu-vis-tog');
	                click_el.addClass('menu-vis-tog');
	                click_el.next('ul').addClass('menu-vis');
	            }
	        } else {
	            if(!$(event.target).closest('.menu-vis').length) {
	                $('ul.menu-vis').removeClass('menu-vis');
	                $('.aftrelink').removeClass('menu-vis-tog');
	            }
	        }
	    });
	}
});

function responsiveMenu()
{
   if ($(document).width() <= 991 && responsiveflagMenu == false)
	{
		menuChange('enable');
		responsiveflagMenu = true;
	}
	else if ($(document).width() >= 992)
	{
		menuChange('disable');
		responsiveflagMenu = false;
	}
}

function menuChange(status)
{
	status == 'enable' ? mobileInit(): desktopInit();
}

function desktopInit()
{
	menuGroov.off();
	$(".navi-main-frame").removeClass('active');
	$(".navi-main-frame").css({"display": "flex"});
	$('#nav-icon3').removeClass('open');
	$('.mainnavi .top-menu > li > ul').removeClass('menu-mobile').removeAttr('style').parent().find('.menu-mobile-grover').remove();
	$('.mainnavi .top-menu').removeAttr('style');
}

function mobileInit()
{
	$('.mainnavi .top-menu').removeAttr('style');
	$(".navi-main-frame").css({"display": "none"});

	menuGroov.on('click', function(e){
		$(".navi-main-frame").toggleClass('active').slideToggle(500);
		$('#nav-icon3').toggleClass('open');
		// $(this).toggleClass('active').parent().find('ul.top-menu').stop().slideToggle('medium');
		return false;
	});

	$('.mainnavi .top-menu > li ul').addClass('menu-mobile clearfix').parent().prepend('<div class="menu-mobile-grover"></div>');

	$(".mainnavi .top-menu .menu-mobile-grover").on('click', function(e){
		var subMenu = $(this).parent().children('ul.menu-mobile');
		if (subMenu.is(':hidden'))
		{
			subMenu.slideToggle('medium');
			$(this).addClass('active');
		}
		else
		{
			subMenu.slideToggle('medium');
			$(this).removeClass('active');
		}
		return false;
	});
}
function ScrollToTopProcess() {
	setTimeout(function() {
	  $('html, body').animate({
		scrollTop: $("#process").offset().top - 210
	  }, 600);
	}, 0);
  }